import * as yup from 'yup'

const createSchema = function () {
  return yup.object({
    /**
     * Стандартный обязательный параметр для Битрикс форм.
     * Можете передаваться как hidden поле. Можно указать сразу в схеме,
     * в форме или поле. Как угодно. Но использование с схеме
     * упростит отладку и тестирование.
     */
    WEB_FORM_ID: yup
      .string()
      .trim()
      .default('10')
      .required('${label} надо указать ID формы'),
    /**
     * В битрикс поля форм имеют согласованные именования. Они уникальны
     * в рамках одного экземпляра Битрикс, одной установки. Цифры в именах
     * вообще ничего не значат, это просто суффикс для сохранения уникальности
     * имени. Все поля передаются в $_POST массиве, компонент просто напросто
     * "забирает" поля связанные с идентификатором формы. То сеть поля можно
     * отправить на сервер любым способом. Все предельно стандартно.
     *
     * @see https://dev.1c-bitrix.ru/api_help/form/htmlnames.php
     */
    form_text_85: yup
      .string()
      .trim()
      .default('')
      .required('${label} должно быть заполнено.')
      .label('Фамилия'),
    form_text_86: yup
      .string()
      .trim()
      .default('')
      .required('${label} должно быть заполнено.')
      .label('Имя'),
    form_text_94: yup
      .string()
      .trim()
      .default('')
      .required('${label} должно быть заполнено.')
      .label('СНИЛС'),
    form_text_78: yup
      .string()
      .default('')
      .required('${label} должен быть заполнен.')
      .test(
        'mobile-phone',
        'Требуется указать мобильный номер российского оператора.',
        (value) => {
          /**
           * Перед проверкой формата удалить пробелы
           * и дефисы. Таким образом логика упрощается, а смысл остается.
           */
          const _value = String(value).replace(/[\s-]*/g, '')
          /**
           * строка начинается с группы, в которой могут быть
           * (+7|+8|7|8) или вообще отсутствовать символы. Необязательным
           * считается вся группа или символ `+` внутри группы. Затем
           * обязательно цифра 9 и за ней девять любых цифр. Например, 9000000000.
           * То есть обязательная часть это десять цифр начинающихся с девятки.
           */
          return /^(\+?7|8)?9\d{9}$/.test(_value)
        }
      )
      .label('Телефон'),
    form_email_79: yup
      .string()
      .default('')
      .trim()
      .email('Введите корректный адрес электронной почты')
      .required('Email обязателен')
      .label('Email'),
    form_date_77: yup
      .string()
      .trim()
      .default('')
      .required('${label} должно быть заполнено.')
      .label('Дата рождения'),
    form_hidden_80: yup
      .string()
      .default('Да'),
    agreement: yup
      .boolean()
      .default(true)
      .required('Необходимо отметить согласие')
      .label('Согласие с условиями'),
    })
}

export {
  createSchema
}
